import React, { useState } from "react";
import classes from "../CSS/routes.module.css";
import speaker from "../assets/speaker.jpg";
import CustomNavbar from "../components/navbar";
import Footer from "../components/footer";
import Aos from "aos";
import "aos/dist/aos.css";
import { Button } from "react-bootstrap";
import "../App.css";
import { db } from "../firebase";


function Contact() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [message, setMessage] = useState("");

    const [loader, setLoader] = useState(false);

    function handleSubmit(e) {
        e.preventDefault();
        setLoader(true);


        db.collection('contacts').add({
            name: name,
            email: email,
            number: number,
            message: message,
        })
            .then(() => {
                alert("Query has been submitted, get back to you shortly!");
                setLoader(false);
            })
            .catch((error) => {
                alert(error.message);
                setLoader(false);
            });

        setName("");
        setEmail("");
        setNumber("");
        setMessage("");
    }
    Aos.init({ duration: 1000 });
    return (
        <>
            <div style={{
                backgroundImage: `url(${speaker})`,
                color: "white",
                fontFamily: "Lexend Giga"
            }} className={classes.parallax}>
                <CustomNavbar />
                <div className={classes.parallax} style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                }}>

                    <center><h1 data-aos="fade-down" className={classes.Header}>Have a voice. Have a choice.</h1></center>
                </div>
            </div>
            <div style={{ backgroundColor: "#EBEBEB", backgroundSize: "100% 100%", paddingTop: "40px" }}>
                <div className="form" onSubmit={handleSubmit} style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                }}>
                    <form className="form">
                        <center><h1 data-aos="fade-right" style={{ fontWeight: "bold", borderBottom: "2px solid #efb1ff", paddingBottom: "20px" }}>Get in touch</h1> <p>Hi! Let us know how we can help and we’ll respond shortly.</p></center><br />
                        <center>
                            <p><input className={classes.Input} type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)}></input></p>
                            <p><input className={classes.Input} type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}></input></p>
                            <p><input className={classes.Input} type="phone" placeholder="Phone number" value={number} onChange={(e) => setNumber(e.target.value)}></input></p>
                            <p><input className={classes.InputMore} type="text" placeholder="How can we help?" value={message} onChange={(e) => setMessage(e.target.value)}></input></p>
                            <p><Button type="submit" style={{ borderRadius: "20px", width: "100px" }} variant="light">Send <i class="fas fa-paper-plane"></i></Button></p>
                        </center>
                        <br /><br />
                    </form>


                </div>
                <Footer />
            </div>
        </>
    );
}
export default Contact;